import * as Constants from "./Constants";

/**
* Functions scoped at the module level of the Astro library
*/

/**
 * Reduces an angle in degrees to lie between 0 and 360
 */
export function reduceAngle360(angle: number): number {
    while (angle < 0) {
        angle += 360;
    }
    while (angle > 360) {
        angle -= 360;
    }
    return angle;
}

/**
 * Reduces an angle in radians to lie between 0 and 2*pi
 */
export function reduceAngleTwoPi(angle: number): number {
    let nrevs = Math.floor(angle / Constants.TWOPI);
    return angle - nrevs * Constants.TWOPI;
}

/**
 * Get the string representing the nearest 16 point compass direction
 */
export function getCompassString(azimuth: number): string {
    let deltaAngle = 360 / 16;
    let strings = ['N', 'NNE', 'NE', 'ENE', 'E', 'ESE', 'SE', 'SSE', 'S', 'SSW', 'SW', 'WSW', 'W', 'WNW', 'NW', 'NNW'];

    // Make sure azimuth is in the range 0 to 360
    azimuth = reduceAngle360(azimuth);

    let index = Math.floor((azimuth + deltaAngle * 0.5) / deltaAngle);
    if (index > 15)
        index = 0;

    return strings[index];
}

/**
 * Compute hypebolic sine of given number
 */
export function sinh(x: number): number {
    if (Math.sinh)
        return Math.sinh(x);

    let ex = Math.exp(x);
    return (ex - 1 / ex) / 2;
}

/**
 * Compute hypebolic cosine of given number
 */
export function cosh(x: number): number {
    if (Math.cosh)
        return Math.cosh(x);

    let ex = Math.exp(x);
    return (ex + 1 / ex) / 2;
}


// WEBPACK FOOTER //
// ./src/Globals.ts